document.addEventListener("DOMContentLoaded", function() {

    let $form = document.getElementById( "js-search" );
    let $input = document.getElementById( "js-search-input" );

    $form.addEventListener( 'submit', function( event ) {
        // Stop submit
        event.preventDefault();
        // Input text
        let phrase = ComplicateIt( $input.value );
        // URL
        let url = "https://epo.plzen.eu/irj/portal/anonymous?standAlone=true&search=" + phrase;
        // Open in new tab
        window.open( url, "_blank" ).focus();
    } );

    // Dlazdice s vice odkazy - na touch zarizenich prvni tap odkryje odkazy
    let $cardsLinks = document.querySelectorAll( ".js-card-links" );

    if ( $cardsLinks.length ) {

        $cardsLinks.forEach( function( $card ) {

            $card.addEventListener( 'click', function( event ) {
                // Mys resi hover, klavesnice focus-within - oboji v CSS
                if ( window.matchMedia( "(hover: hover)" ).matches ) {
                    return;
                }
                // Klik na odkaz uvnitr prekryvu nechame projit
                if ( event.target.closest( "a" ) ) {
                    return;
                }
                event.preventDefault();
                // Zavrit ostatni dlazdice
                $cardsLinks.forEach( function( $other ) {
                    if ( $other !== $card ) {
                        $other.classList.remove( "is-open" );
                    }
                } );
                $card.classList.toggle( "is-open" );
            } );

        } );

        // Tap mimo dlazdici prekryv zavre
        document.addEventListener( 'click', function( event ) {
            if ( event.target.closest( ".js-card-links" ) ) {
                return;
            }
            $cardsLinks.forEach( function( $card ) {
                $card.classList.remove( "is-open" );
            } );
        } );

    }

} );

function ComplicateIt( str ) {

    let arr1 = [];

    for ( let n = 0, l = str.length; n < l; n++ ) {
        let hex = "000" + Number( str.charCodeAt(n) ).toString( 16 );
        hex = hex.substring( hex.length - 3, hex.length );
        arr1.push( hex );
    }

    return arr1.join('');
}